import { styled } from '../../theme';
import { Waiter } from '../Waiter';

export const List = styled(Waiter)`
	min-height: 70px;
`;
